import { Box, Divider, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import Paper from '@mui/material/Paper';

interface HoverMenuProps {
  openMenuIndex: number;
  menuChildren: any[];
  handleMouseLeave: (index: number) => void;
  handleMenuClose: (index: number, link?: string) => void;
  handleMouseEnterMenu: (index: number) => void;
  drawerWidth: number;
}

export const HoverMenu = ({
  openMenuIndex,
  menuChildren,
  handleMouseLeave,
  handleMenuClose,
  handleMouseEnterMenu,
  drawerWidth
}: HoverMenuProps) => {
  return (
    <Paper
      onMouseEnter={() => handleMouseEnterMenu(openMenuIndex)}
      onMouseLeave={() => handleMouseLeave(openMenuIndex)}
      sx={{
        position: 'absolute',
        top: 0,
        left: `calc(${drawerWidth}px - 24px)`,
        ml: 1,
        minWidth: drawerWidth * 1.5,
        height: 'calc(100% - 32px)',
        mt: 2,
        boxSizing: 'border-box',
        borderRadius: 4,
        boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.25)',
        py: 1,
        zIndex: 1300,
        backgroundColor: 'primary.main',
        animation: 'slideIn 0.3s ease-out',
        '@keyframes slideIn': {
          '0%': {
            opacity: 0,
            transform: 'translateX(-20px)'
          },
          '100%': {
            opacity: 1,
            transform: 'translateX(0)'
          }
        }
      }}
    >
      <List sx={{ pt: 15, px: 1 }}>
        {menuChildren?.map((option: any, optIndex: number) => (
          <Box key={optIndex}>
            <ListItem
              onClick={() => handleMenuClose(openMenuIndex, option?.link)}
              sx={{
                fontSize: 11,
                pl: 3,
                color: 'rgb(255, 255, 255)',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'action.hover'
                }
              }}
            >
              {option?.icon && (
                <ListItemIcon
                  sx={{
                    color: 'white',
                    minWidth: 'auto',
                    mr: 1,
                    '& .MuiSvgIcon-root': {
                      color: 'white',
                      fontSize: '1rem'
                    }
                  }}
                >
                  {option?.icon}
                </ListItemIcon>
              )}
              <ListItemText
                primary={option?.primary}
                primaryTypographyProps={{
                  variant: 'body2',
                  sx: { fontSize: 13, fontWeight: 300 }
                }}
              />
            </ListItem>
            <Divider variant="middle" sx={{ backgroundColor: 'rgba(255, 255, 255, 0.4)', mb: 1 }} />
          </Box>
        ))}
      </List>
    </Paper>
  );
};

export default HoverMenu;
